var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  "label-width": "120px",
                  model: _vm.queryCondition,
                  "label-position": "right",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "单据编号",
                                      prop: "applyNo",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请输入单据编号",
                                      },
                                      model: {
                                        value: _vm.queryCondition.applyNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "applyNo",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.applyNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "主题", prop: "subject" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请输入主题",
                                      },
                                      model: {
                                        value: _vm.queryCondition.subject,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "subject",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.subject",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "类型", prop: "applyType" },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "handle-input",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: "类型",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.queryCondition.applyType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "applyType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.applyType",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t("common.all"),
                                            value: "",
                                          },
                                        }),
                                        _vm._l(
                                          _vm.applyTypeOptions,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label:
                                                  _vm._f("inputChoiceI18n")(
                                                    item
                                                  ),
                                                value: item.code,
                                              },
                                            })
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "入围供应商",
                                      prop: "supplierCode",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "suffix-icon": "el-icon-search",
                                        clearable: "",
                                      },
                                      on: { clear: _vm.clearSupplierName },
                                      nativeOn: {
                                        click: function ($event) {
                                          _vm.showSelSupplierDialog = true
                                          _vm.SupplierNameDialogReset = true
                                        },
                                      },
                                      model: {
                                        value: _vm.queryCondition.supplierCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "supplierCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.supplierCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "申请单状态",
                                              prop: "status",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  placeholder: "申请单状态",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.status",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t("common.all"),
                                                    value: "all",
                                                  },
                                                }),
                                                _vm._l(
                                                  _vm.statusListOptions,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label:
                                                          _vm._f(
                                                            "inputChoiceI18n"
                                                          )(item),
                                                        value: item.code,
                                                      },
                                                    })
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "报价状态",
                                              prop: "quotationStatus",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  placeholder: "报价状态",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .quotationStatus,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "quotationStatus",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.quotationStatus",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t("common.all"),
                                                    value: "",
                                                  },
                                                }),
                                                _vm._l(
                                                  _vm.quotationStatusOptions,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label:
                                                          _vm._f(
                                                            "inputChoiceI18n"
                                                          )(item),
                                                        value: item.code,
                                                      },
                                                    })
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "创建人",
                                              prop: "name",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入创建人",
                                              },
                                              model: {
                                                value: _vm.queryCondition.name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "报价确认申请单",
                                              prop: "sourcingNo",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                placeholder:
                                                  "请输入报价确认申请单",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.sourcingNo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "sourcingNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.sourcingNo",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "报价确认状态",
                                              prop: "sourcingStatus",
                                            },
                                          },
                                          [
                                            _c("IcSelect", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "TT_SOURCING_HEAD",
                                                field: "STATUS",
                                                clearable: "",
                                                allValues: true,
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .sourcingStatus,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "sourcingStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.sourcingStatus",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "创建日期(从)",
                                              prop: "createDate",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "date",
                                                placeholder: "选择日期",
                                                "value-format": "yyyy-MM-dd",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.createDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "createDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.createDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "创建日期(至)",
                                              prop: "createEndDate",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "value-format": "yyyy-MM-dd",
                                                type: "date",
                                                placeholder:
                                                  _vm.$t("common.selDate"),
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .createEndDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "createEndDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.createEndDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "8位码",
                                              prop: "eightBitCodesStr",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "textarea",
                                                autosize: {
                                                  minRows: 2,
                                                  maxRows: 4,
                                                },
                                                clearable: "",
                                                placeholder: "请输入8位码",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .eightBitCodesStr,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "eightBitCodesStr",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.eightBitCodesStr",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.queryData(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.search")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.restQueryFormThis },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.ProApplyInfoCreateNew,
                    expression: "ProApplyInfoCreateNew",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.addNewApply(-1)
                  },
                },
              },
              [_vm._v("新增")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.proApplyDeleteApply,
                    expression: "proApplyDeleteApply",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "danger" },
                on: {
                  click: function ($event) {
                    return _vm.delApply()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("common.del")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.proApplyCloseApply,
                    expression: "proApplyCloseApply",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.closeApply()
                  },
                },
              },
              [_vm._v("作废")]
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.tableData,
              border: "",
              "max-height": "470",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                align: "center",
                fixed: "",
                width: "56",
                label: _vm.$t("common.select"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            disabled: scope.row.status == "3",
                            label: scope.row.ttQuotationApplyId,
                          },
                          nativeOn: {
                            change: function ($event) {
                              return _vm.getSelectRow(scope.row)
                            },
                          },
                          model: {
                            value: _vm.radioVal,
                            callback: function ($$v) {
                              _vm.radioVal = $$v
                            },
                            expression: "radioVal",
                          },
                        },
                        [_vm._v(" ")]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                fixed: "",
                sortable: "",
                prop: "applyNo",
                label: "单据编号",
                "min-width": "100px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openQuotationApplyDetail(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.applyNo))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "subject",
                label: "主题",
                "min-width": "140px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "supplierNames",
                label: "入围供应商",
                "min-width": "150px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "name",
                label: "创建人",
                "min-width": "160px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "createDate",
                label: "创建日期",
                "min-width": "100px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "statusI18n",
                label: "申请单状态",
                "min-width": "100px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "roundNumber",
                label: "报价轮次",
                "min-width": "100px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "quotationStatusI18n",
                label: "报价状态",
                "min-width": "100px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "sourcingNo",
                label: "报价确认申请单",
                "min-width": "140px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm._l(
                      scope.row.sourcingList,
                      function (item, index) {
                        return _c(
                          "el-link",
                          {
                            key: index,
                            staticStyle: { display: "block" },
                            attrs: { type: "primary" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.openSoucingInfo(item.sourcingNo)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.sourcingNo))]
                        )
                      }
                    )
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "sourcingStatus",
                label: "报价确认状态",
                "min-width": "110px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm._l(
                      scope.row.sourcingList,
                      function (item, index) {
                        return _c(
                          "el-link",
                          {
                            key: index,
                            staticStyle: { display: "block" },
                            attrs: { type: "info" },
                          },
                          [_vm._v(_vm._s(item.status))]
                        )
                      }
                    )
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.pageSizeChange,
                "current-change": _vm.pageNumberChange,
              },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.showSelSupplierDialog,
              "append-to-body": "",
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showSelSupplierDialog = $event
              },
            },
          },
          [
            _vm.SupplierNameDialogReset
              ? _c("SelSupplier", {
                  ref: "supplierSelRef",
                  attrs: { multipleSelectionFlag: false },
                  on: { subCallMethod: _vm.selectSupplierMethod },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }